module.exports = __webpack_public_path__ + "img/addFit.a8b8024e.png";